import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getPortalToken, portalMe } from "@/lib/portalApi";

export default function ProtectedPortalRoute({ children }) {
  const [status, setStatus] = useState("checking");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!getPortalToken()) {
        if (!cancelled) setStatus("denied");
        return;
      }
      try {
        await portalMe();
        if (!cancelled) setStatus("ok");
      } catch {
        if (!cancelled) setStatus("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-black text-[#F5F5F0] flex items-center justify-center">
        <div className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3]">Checking session…</div>
      </div>
    );
  }
  if (status === "denied") {
    return <Navigate to="/portal/login" replace state={{ from: location }} />;
  }
  return children;
}
